module.exports = __webpack_public_path__ + "img/websitetheme.fdb9717b.svg";